import { AnchorHTMLAttributes, ReactNode } from "react"
import { Link, useParams } from "react-router-dom"
import { stringify } from "querystringify"

import { Cities } from "./Cities"

import { Analytics } from "utils/analytics"
import { useTabletOrMobile } from "utils/hooks"
import { getCurrentStatus } from "app/AppRouter/utils"
import { FunnelStorage, isAllowedToBeBookingSource } from "modules/FunnelAnalytics"
import { MIN_PRICE, MAX_PRICE } from "modules/PsyProfile/common/constants"
import { useSearchParams } from "utils/customHooks"
import { APP_STATUSES } from "utils/AppStatusContext"
import { SearchFormModel } from "modules/NewClientSurvey/common"

export function SearchPageLink({
    children,
    ...props
}: AnchorHTMLAttributes<HTMLAnchorElement> & {
    children: ReactNode
}) {
    const isTabletOrMobile = useTabletOrMobile()
    const searchParams = useSearchParams()
    const pathParams = useParams<{ id: string }>()
    const subject = searchParams.get("subject") ?? undefined
    const city = searchParams.get("city") ?? undefined
    const formOfWork = searchParams.get("form_of_work") ?? undefined
    const sex = searchParams.get("sex") ?? undefined
    const priceFrom = parseInt(searchParams.get("price_from") as string) || MIN_PRICE
    const priceTo = parseInt(searchParams.get("price_to") as string) || MAX_PRICE
    const competences = searchParams.get("competences")?.split("|").map(parseInt)
    const surveyModelData = {
        city,
        subject,
        form_of_work: formOfWork,
        sex,
        price_from: priceFrom,
        price_to: priceTo,
        competences,
    }

    const catalogQs = {
        form_of_work: formOfWork || "any",
        price_from: priceFrom,
        price_to: priceTo,
    }

    const cityShortcut = Cities.getShortcut(city)
    const citySlug = cityShortcut ? `/${cityShortcut}` : undefined

    function onClick() {
        clickHandler(pathParams.id, surveyModelData)
    }

    return (
        <Link
            to={`/psychologists${citySlug ?? ""}?${stringify(catalogQs)}`}
            onClick={onClick}
            target={isTabletOrMobile ? undefined : "_blank"}
            {...props}
        >
            {children}
        </Link>
    )
}

function clickHandler(id: string | undefined, data: SearchFormModel) {
    const currentStatus = getCurrentStatus()
    Analytics.go_to_search({
        ...data,
        ...{ price_category: `${data.price_from}_${data.price_to}` },
    })
    if (currentStatus && isAllowedToBeBookingSource(currentStatus)) {
        FunnelStorage.getInstance().saveItem(
            currentStatus,
            currentStatus === APP_STATUSES.psy_collection ? id : undefined,
            undefined
        )
    }
}
